export default __webpack_public_path__ + "static/media/venuxx-bar.b74b5c29.jpg";